import { createApp } from "vue";
import "normalize.css/normalize.css";
import "virtual:uno.css";
import "@/style.css";
import store from "@/store";
import router from "@/router";
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import App from "@/App.vue";

const app = createApp(App);
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}
app.use(store);
app.use(router);
app.mount("#app");
